module.exports = __webpack_public_path__ + "static/media/termsAndConditions_eng.bf1560c0.pdf";